
import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionLoadGridDataRequest,
  actionLoadGridDataSuccess,
  actionLoadGridDataFail,
} from 'react-redux-app/lib/modules/grid/actions';
import { actionAddSiteAliases } from './siteAliases';

import { SITE_ALIASES_GRID_NAME } from '../constants';
import { SITE_ALIASES_SCHEMA } from '../schemas';

import { getCurrentSiteId } from '../../site/selectors';

import { removeBlankFields } from 'react-redux-app/lib/modules/core/utils';
import { getGridFilter } from '../utils';


export const actionLoadSiteAliasesRequest = () => (
  (dispatch, getState, { apiClientHelper, history: { location } }) => {
    dispatch(actionLoadGridDataRequest(SITE_ALIASES_GRID_NAME));

    const filter = getGridFilter(location);
    const newFilter = { ...filter, siteId: filter.siteId || getCurrentSiteId(getState()) };

    return apiClientHelper.get(
      '/rest/webmaster/site_alias',
      { params: removeBlankFields(newFilter) },
      SITE_ALIASES_SCHEMA
    ).then(
      ({ entities, result }) => {
        dispatch(actionAddSiteAliases(entities.siteAliases));

        dispatch(actionLoadGridDataSuccess(
          SITE_ALIASES_GRID_NAME, result.items, result.count, result.summary
        ));
      },
      error => {
        dispatch(actionLoadGridDataFail(SITE_ALIASES_GRID_NAME, error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
